import { getLogonIdToGetOrders } from '../../helpers/ProfileHelper';
import { callGetProducts } from '../../services/ProductService';
import {
  SET_PRODUCTS,
  PRODUCTS_LOADING,
  PRODUCTS_ERROR,
  PRODUCTS_NOT_FOUND,
  SET_SELECTED_PRODUCT,
} from '../types/ProductTypes';

export const setProducts = (products) => {
  return { type: SET_PRODUCTS, products };
};

export const productsLoading = () => {
  return { type: PRODUCTS_LOADING };
};

export const productsError = () => {
  return { type: PRODUCTS_ERROR };
};

export const productsNotFound = () => {
  return { type: PRODUCTS_NOT_FOUND };
};

export const setSelectedProduct = (product) => {
  return { type: SET_SELECTED_PRODUCT, product };
};

export const getProducts = () => {
  return async (dispatch, getState) => {
    const { logonId } = getState().profileReducer.profile;
    const id = getLogonIdToGetOrders(logonId);
    try {
      dispatch(productsLoading());
      const res = await callGetProducts(id);
      if (res.status === 200) {
        dispatch(setProducts(res.data.products));
      } else if (res.status === 404) dispatch(productsNotFound());
      else dispatch(productsError());
    } catch (err) {
      dispatch(productsError());
    }
  };
};
